import React from 'react'
import { useRouteError } from 'react-router-dom';


export default function ErrorPage({msg}: {msg: string}) {
  const error = useRouteError() as Error;
  let errorMessage = msg;
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  }

  return (
    <div className="text-center mt-3">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred:</p>
      <p>
        {errorMessage && <i>{errorMessage}</i>}
      </p>
    </div>
  );
}